import React, { useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';
import DataTableExtensions from 'react-data-table-component-extensions';
import { useHistory } from 'react-router-dom'
import client from "../../services/Api";
import http from '../../services/Api';
import moment from 'moment';

import './index.css'
import { useAuth } from '../../providers/auth';
import swal from 'sweetalert';
import { ModalManager } from 'react-dynamic-modal/lib/Modal';
import EditBeaconModal from './EditBeaconModal';

function AccountDevices() {
    const [loading, setLoading] = useState(true);
    const [devices, setDevices] = useState([]);
    const [tableData, setTableData] = useState(null);
    const [tableKey, setTableKey] = useState(0);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const history = useHistory();
    const { user } = useAuth()

    const query = new URLSearchParams(window.location.search);
    const client_id = query.get('id');
    const user_id = query.get('id');
    const numDevices = query.get('numDevices');

    useEffect(() => {
        init()
        setLoading(true)
    }, []);

    const columns = [
        {
            name: 'Nome',
            selector: 'name',
            sortable: false,
            width: '15%',
        },
        {
            name: 'Número de série',
            format: row => row.model != null && row.model != undefined && row.model != '' ? row.model : '--',
            selector: 'model',
            sortable: false,
            width: '12%',
          },
        {
            name: 'Endereço Mac',
            selector: 'mac',
            sortable: false,
            width: '12%',
        },
        {
            name: 'Último sincronismo',
            selector: 'lastSyncDate',
            format: row => row.lastSyncDate != null ? moment.utc(row.lastSyncDate).local().format('DD/MM/YYYY HH:mm:ss') : '--',
            sortable: false,
            width: '12%',
        },
        {
            name: 'Qtd de registros',
            sortable: false,
            width: '12%',
            cell: (row) =>
                <Row>
                    <Col>
                        {row.logsLoading ? <p style={{ marginTop: '15px' }}>Carregando...</p> : row.logsCount != null ? row.logsCount : <a href="#" style={{ textAlign: 'center' }} onClick={() => { getHistoricCount(row) }}>Clique para ver</a>}
                    </Col>
                </Row>
        },
        {
            name: 'Data de criação',
            format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
            selector: 'created_at',
            sortable: true,
            width: '12%',
        },
        {
            cell: (row) =>
                <Row>
                    <Col>
                        <div className="actions">
                            <button className="add-beacon edit-beacon" onClick={() =>
                                openEditBeaconModal(row.mac, row.name)
                            }>
                                Alterar Nome
                  </button>
                        </div>
                    </Col>

                    <Col>
                        <button className="edit-beacon" onClick={() =>
                            history.push(`/device-history/${row.mac}/${row._id}`, { name: row.name, model: row.model })
                        }>
                            Histórico
                </button>
                    </Col>
                </Row>
            ,
        }
    ];

    const customStyles = {
        rows: {
            style: {
                '&:hover': {
                    backgroundColor: '#03989E',
                    color: 'white',
                    transition: '.2s'
                },
            }
        },
    };

    function changeCheckbox(data, idx) {
        let savedBeacons = devices;

        if (devices.includes(data._id)) {
            savedBeacons.splice(idx);
        } else {
            savedBeacons.push(data._id);
        }
        setDevices(savedBeacons);
    }

    function renderLoading() {
        return (
            <div className="center-page">
                <Spinner animation="border" />
            </div>
        )
    }

    async function init() {
        if (user.profile._id == "6086f50d46258e47f28ec9d5") {
            const response = await getBeacons();
            if (response !== null) {
                const data = response.data;
                data.forEach((item) => {
                    item.model = item.model !== null ? item.model : ''
                    item.key = item.key !== null ? item.key : ''
                })
                console.log(data)
                setTableData({
                    data,
                    columns
                })
            }
            setLoading(false);
        } else {
            const enterprise = await getEnterprise();
            const response = await getBeacons(enterprise);
            if (response !== null) {
                const data = response.data;
                setTableData({
                    data,
                    columns
                })
            }
            setLoading(false);
        }
    }
    function openEditBeaconModal(macid, beaconName) {
        ModalManager.open(<EditBeaconModal mac={macid} beaconName={beaconName} />)
    }

    async function getEnterprise() {
        try {
            const response = await client.get(`/api/user-client-id/${user.id}`)
            const id = response.data._id;
            return id;
        } catch (e) {
            console.log(e)
        }
    }
    async function getBeacons(enterprise) {
        try {
            if (user.profile._id == "6086f50d46258e47f28ec9d5") {
                const response = await client.get("/api/beacon-device/allAdmin");
                return response;
            } else if (user.profile._id == "60846a923c0c98d2837f2e42") {
                const response = await client.get(`/api/devices-by-client/${enterprise}`);
                return response;
            } else {
                const response = await client.get(`/api/devices-by-user/${user.id}`);
                console.log(response)
                return response;
            }
        } catch (e) {
            console.log(e);
        }
        return null;
    }

    function addBeacon() {
        let to_update = 0;
        if (numDevices > 0) {
            to_update = 1
        }

        if (user.profile._id == "60846a923c0c98d2837f2e42") {
            try {
                let response = http.post(`/api/devices/link/client`, {
                    client_id,
                    devices,
                    to_update: to_update
                });
                swal("Dispositivos vínculados com sucesso!",
                    {
                        title: "Sucesso!",
                        buttons: {
                            login: {
                                text: "Voltar para Meus Dispositivos",
                                value: "my-devices",
                            },
                        },
                        icon: "success",
                    })
                    .then((value) => {
                        if (value === 'my-devices') {
                            history.push('/my-devices');
                        }
                    });
                setLoading(false)
            } catch (e) {
                console.log(e)
                setLoading(false);
            }
        } else {
            try {
                let response = http.post(`/api/devices/link/user`, {
                    user_id,
                    devices,
                    to_update: to_update
                });
                swal("Dispositivos vínculados com sucesso!",
                    {
                        title: "Sucesso!",
                        buttons: {
                            login: {
                                text: "Voltar para Meus Dispositivos",
                                value: "my-devices",
                            },
                        },
                        icon: "success",
                    })
                    .then((value) => {
                        if (value === 'my-devices') {
                            history.push('/my-devices');
                        }
                    });
                setLoading(false)
            } catch (e) {
                console.log(e)
                setLoading(false);
            }
        }

    }

    const getHistoricCount = async (device) => {
        try {
            device.logsLoading = true;
            setTableKey((oldKey) => {
                oldKey++
                return oldKey
            });
            const response = await client.get(`/api/beacon-device/${device.mac}/historic-count`)
            device.logsLoading = false;
            device.logsCount = response.data.count;
            setTableData((oldData) => {
                oldData.data.map((item) => {
                    if (item.mac == device.mac)
                        item = device;
                    return item;
                })
                return oldData;
            })
            setTableKey((oldKey) => {
                oldKey++
                return oldKey
            });
        } catch (e) {
            console.log(e);
        }
    }

    function table() {
        return (
            <DataTableExtensions
                {...tableData}
                filterPlaceholder="Pesquisar dispositivos"
                print={false}>
                <DataTable
                    key={tableKey}
                    noDataComponent={
                        <span>Nada encontrado...</span>
                    }
                    pagination={true}
                    customStyles={customStyles}
                    paginationDefaultPage={page}
                    paginationPerPage={rowsPerPage}
                    onChangePage={(page) => setPage(page)}
                    paginationComponentOptions={{ noRowsPerPage: true }}
                    onChangeRowsPerPage={(rowsPerPage, page) => {
                        setPage(page);
                        setRowsPerPage(rowsPerPage)
                    }}
                />
            </DataTableExtensions>
        )
    }

    return (
        <div className="ClientDevices sidenav-margin">
            <AresNavBar />
            <SideBar />
            <div className="content">
                <div className="container-header">
                    <h1>Dispositivos</h1>
                </div>
                {loading ?
                    renderLoading()
                    :
                    <div>
                        <div className="beacon-table">
                            {table()}
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default AccountDevices;